const AUTH_PATH = {
  SIGN_IN: '/sign-in',
  SIGN_IN_PASSWORD: '/sign-in/password',
  VERIFIED: '/email-verification',
  PASSWORD_FORGOT: '/password-forgot',
  PASSWORD_RESET: '/password-reset',
  BRIDGE: {
    INDEX: '/bridge',
    IDENTITY_VERIFICATION: '/bridge/identity-verification',
  },
};

const CHAT_PATH = {
  MAIN: '/chat',
  EVENTS: '/chat/events',
  CHATTING_DETAIL_FN: (chatId: string) => `/chat/${chatId}`,
  CHATTING_DETAIL: '/chat/:chatId',
  CHARACTER: {
    INDEX: '/chat/characters',
    CREATE: '/chat/characters/create',
    DETAIL: '/chat/characters/:characterId',
    EDIT: '/chat/characters/:characterId/edit',
  },
  UNIVERSE: {
    INDEX: '/chat/universes',
    CREATE: '/chat/universes/create',
    DETAIL: '/chat/universes/:universeId',
    EDIT: '/chat/universes/:universeId/edit',
  },
  SCENE: {
    INDEX: '/chat/scenes',
    CREATE: '/chat/scenes/create',
    DETAIL: '/chat/scenes/:sceneId',
    EDIT: '/chat/scenes/:sceneId/edit',
  },
  MY: {
    INDEX: '/chat/my',
    ASSETS: '/chat/my/assets',
    HISTORIES: '/chat/my/histories',
    BOOKMARKS: '/chat/my/bookmarks',
    PROFILE: '/chat/my/profile',
    PROFILE_EDIT: '/chat/my/profile/edit',
  },
  CHAT_PAYMENT: {
    INDEX: '/chat/payment',
    ITEM: '/chat/payment/item',
    FREE: '/chat/payment/free',
    NAP: '/chat/payment/nap',
    SUCCESS: '/chat/payment/success',
    FAIL: '/chat/payment/fail',
  },
  IDENTITY_VERIFICATION: '/chat/identity-verification',
  SETTING: '/chat/setting',
  SEARCH: '/chat/search',
  USERS: {
    PROFILE: '/chat/users/:userId/profile',
    PROFILE_FN: (userId: string) => `/chat/users/${userId}/profile`,
  },
  WITHDRAW: '/chat/withdraw',
};

const BUBBLETAP_PATH = {
  MAIN: '/chat',
  STUDIO: {
    INDEX: '/studio',
    MY_TITLES: '/studio/titles',

    CREATE_TITLE: '/studio/titles/create',
    EDIT_TITLE: '/studio/titles/:titleId/edit',
    EDIT_TITLE_FN: (titleId?: string) => `/studio/titles/${titleId}/edit`,
    EDITOR: '/studio/editor',
    CREATE_CHAPTER: '/studio/editor/edit/:titleId/create',
    CREATE_CHAPTER_FN: (titleId?: string) => `/studio/editor/edit/${titleId}/create`,
    EDIT_CHAPTER: '/studio/editor/edit/:titleId/:chapterId',
    EDIT_CHAPTER_FN: (titleId?: string, chapterId?: string) => `/studio/editor/edit/${titleId}/${chapterId}`,
    STUDIO_ROOT: '/studio',
    PROFILE: '/studio/profile',
  },

  // MY_TITLES: '/studio/titles',
  // CREATE_TITLE: '/studio/titles/create',
  // PROFILE: '/studio/profile',

  // EDIT_TITLE_FN: (titleId?: string) => `/studio/titles/${titleId}/edit`,
  // CREATE_CHAPTER: (titleId?: string) => `/studio/editor/edit/${titleId}/create`,
  // EDIT_CHAPTER: (titleId?: string, chapterId?: string) => `/studio/editor/edit/${titleId}/${chapterId}`,
  // STUDIO_ROOT: '/studio',
  // STUDIO: '/studio',

  // Web Consume
  BUBBLE_PICK: '/bubblepick',
  HOT_TAP: '/hottap',
  DISCOVER: '/discover',
  TITLES: '/titles',
  TITLE_DETAIL: '/titles/:titleId',
  TITLE_DETAIL_FN: (titleId: string) => `/titles/${titleId}`,
  CHAPTER: '/titles/:titleId/chapters/:chapterId',
  CHAPTER_FN: (titleId: string, chapterId: string, languageCode?: string) =>
    `/titles/${titleId}/chapters/${chapterId}?languageCode=${languageCode ?? 'ko'}`,

  AI: '/ai',
  AI_INFO: '/ai/info',
  COMMUNITY: '/community',
  COMMUNITY_DETAIL: (communityId: string) => `/community/${communityId}`,
  SETTING: '/setting',
  WITHDRAWAL: '/withdrawal',
  AD_REWARDS: '/ad-rewards',
  POLICY: {
    INDEX: '/policy',
    MOBILE: '/m/policy',
    BUBBLEUP_VERIFICATION: '/policy/bubbleup-verification',
    BUBBLEUP_TERMS: '/policy/bubbleup-terms',
  },
  USER_PROFILE: '/users/:userId/profile',
  USER_PROFILE_FN: (userId: string) => `/users/${userId}/profile`,
  MY_PROFILE: '/my/profile',
  MY_PROFILE_EDIT: '/my/profile/edit',
  IDENTITY_VERIFICATION: '/my/profile/identity-verification',
  BANK_ACCOUNT_VERIFICATION: '/my/profile/bank-account-verification',
  BANK_ACCOUNT_VERIFICATION_EDIT: '/my/profile/bank-account-verification/edit',
  WEB_PAYMENT: {
    INDEX: '/payment', // 버블 충전소
    ITEM: '/payment/item', // 샴푸/포션 충전소
    FREE: '/payment/free', // free
    SUCCESS: '/payment/success', // success
    FAIL: '/payment/fail', // fail
  },
} as const;

const CONTEST_PATH = {
  MAIN: '/contests',
  ESCAPE_CHALLENGE: '/contests/1',
  DIRECTION_CHALLENGE: '/contests/2',
  REMODELING_CHALLENGE: '/contests/3',
  ORIGINAL_STORY_CHALLENGE: '/contests/4',
  FOLKLORE_CHALLENGE: '/contests/5',
  IDEA_CHALLENGE: '/contests/6',
  SPORTS_CHALLENGE: '/contests/7',
  SUMMER_CHALLENGE: '/contests/8',
  // CURRENT_CONTEST: function () {
  //   return getIsContestOngoing(CONTEST8_DISPLAY_START_DATE, CONTEST8_DISPLAY_END_DATE)
  //     ? this.SUMMER_CHALLENGE
  //     : this.SPORTS_CHALLENGE;
  // },
  EVENTS: '/events',
  BUBBLE_UP_CHALLENGE: '/bubbleup-challenge',
};

export { AUTH_PATH, CHAT_PATH, BUBBLETAP_PATH, CONTEST_PATH };
